export class FindAllOrganisationMembers {
  public static readonly type =
    '[User/Organisations] FindAllOrganisationMembers';
}
